import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
    promoCodeRedeemStatusByIndexSelector,
    rawPromoCodeSelector,
    promoCodeSelector,
    selectedVehicleSelector,
} from 'booking/selectors'
import { redeemPromoCode, removePromoCode, setRawPromoCode } from 'booking/actions'
import { userSelector } from 'auth/selectors'

const usePromoCodeData = ({ currentItemIndex, rate }) => {
    const dispatch = useDispatch()
    const selectedVehicle = useSelector(selectedVehicleSelector)
    const rawPromoCode = useSelector(rawPromoCodeSelector)
    const promoCode = useSelector(promoCodeSelector)
    const user = useSelector(userSelector)

    const { isPromoCodeLoading, promoCodePendingError } = useSelector(state =>
        promoCodeRedeemStatusByIndexSelector(state, currentItemIndex)
    )

    const [promoCodeError, setPromoCodeError] = useState(promoCodePendingError)
    const [successPromoCode, setSuccessPromoCode] = useState(false)

    useEffect(() => {
        setPromoCodeError(promoCodePendingError)
    }, [promoCodePendingError])

    const onAddPromoCode = () => {
        dispatch(
            redeemPromoCode({
                id: currentItemIndex,
                rate,
            })
        )
    }

    useEffect(() => {
        if (selectedVehicle.length === 0 && user) {
            rawPromoCode !== '' && onAddPromoCode()
        }
    }, [user])

    useEffect(() => {
        !rawPromoCode && dispatch(removePromoCode())

        if (rawPromoCode) {
            dispatch(
                redeemPromoCode({
                    id: currentItemIndex,
                    rate,
                })
            )
        }
    }, [rate])

    useEffect(() => {
        if (Boolean(promoCode?.barcode) && promoCode?.statusCode === 200) {
            setSuccessPromoCode(true)
        }
        if (rawPromoCode === '') {
            setSuccessPromoCode(false)
        }
    }, [promoCode, rawPromoCode])

    useEffect(() => {
        if (rawPromoCode !== '' && promoCode?.statusCode === -1) {
            setPromoCodeError(<T>booking.promo.code.error</T>)
        }
    }, [promoCode])

    return {
        rawPromoCode,
        setRawPromoCode: value => dispatch(setRawPromoCode(value)),
        removePromoCode: () => dispatch(removePromoCode()),
        onAddPromoCode,
        promoCodeError,
        successPromoCode,
        isPromoCodeLoading,
    }
}

export default usePromoCodeData
